import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countWord'
})
export class CountWordPipe implements PipeTransform {

  transform(value: string, maxNumber: number): number {
    let text = value || '';
    let words = text
      .trim();
      return words.length;
  }

}
